import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  enteredDomainRes: {},
  resourceDomainRes: [],
  purchasedDomain: "",
  currency: "",
  currencyCost: 0,
  loadingResource: false,
  summary: "",
};

const domainSlice = createSlice({
  name: "DomainSlice",
  initialState,
  reducers: {
    setEnteredDomainRes: (state, { payload }) => {
      state.enteredDomainRes = payload;
      state.loadingResource = true;
    },
    setCurrency: (state, { payload }) => {
      state.currency = payload;
    },
    setCurrencyCost: (state, { payload }) => {
      state.currencyCost = payload;
    },
    setResourceDomainRes: (state, { payload }) => {
      state.resourceDomainRes = payload;
      state.loadingResource = false;
    },
    setLoadindResourse: (state, { payload }) => {
      state.loadingResource = payload;
    },
    setPurchasedDomain: (state, { payload }) => {
      state.purchasedDomain = payload;
    },
    setSummaryInfo: (state, { payload }) => {
      state.summary = payload;
    },
  },
});

export const domainReducer = domainSlice.reducer;
export const {
  setEnteredDomainRes,
  setCurrency,
  setCurrencyCost,
  setResourceDomainRes,
  setPurchasedDomain,
  setSummaryInfo,
  setLoadindResourse,
  resourceDomainRes,
} = domainSlice.actions;
